// Section for import npm components -----------------------------------------------------------------------------------
import React from 'react';

// MUI components
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// Section for import custom components --------------------------------------------------------------------------------

// Section for type definition -----------------------------------------------------------------------------------------
type CitiesDescriptionProps = {
  selectedCities: {
    city_name: string;
    aiTextDescription: string | false;
  }[];
};

export default function CitiesDescription(props: CitiesDescriptionProps) {
  const { selectedCities } = props;
  const hasAiTextDescription = selectedCities[0].aiTextDescription;
  // Section for render component --------------------------------------------------------------------------------------
  if (!hasAiTextDescription) return null;
  return (
    // Section for render Mobile mode ----------------------------------------------------------------------------------
    <Box className="md:w-full md:mx-auto md:px-24 max-md:mx-5 mb-16 max-md:mb-12">
      <Typography className="border-solid border-l-2 border-rf-black relative mb-6 max-md:mb-5 pl-4 text-lg font-bold before:absolute before:top-1 before:left-[-16px]">
        {selectedCities[0].city_name}の特徴
      </Typography>
      <Typography className="text-base">{selectedCities[0].aiTextDescription}</Typography>
    </Box>
  );
}
